import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Brand from '../components/Brand';
import { authAPI } from '../lib/api';
import { clearSession, getUser } from '../lib/auth';
import { getLang, setLang, t } from '../lib/i18n';

// Phase-0 home: proves auth + brand bridge end-to-end. The staff console and
// member wallet replace this in Phases 1–3.
export default function Home() {
  const navigate = useNavigate();
  const user = getUser();
  const [, rerender] = useState(0);

  const signOut = async () => {
    try {
      await authAPI.logout();
    } catch {
      /* stateless — ignore */
    }
    clearSession();
    navigate('/login', { replace: true });
  };

  const toggleLang = () => {
    setLang(getLang() === 'es' ? 'en' : 'es');
    rerender((n) => n + 1);
  };

  return (
    <div className="min-h-screen">
      <header className="flex items-center justify-between border-b border-mms-border bg-mms-topbar px-4 py-3 sm:px-6">
        <Brand size="md" />
        <div className="flex items-center gap-3">
          <button
            onClick={toggleLang}
            className="rounded-md border border-mms-border px-2.5 py-1.5 text-xs text-mms-muted hover:border-[var(--mms-hover-border)]"
            title={t('Language')}
          >
            {getLang() === 'es' ? 'ES' : 'EN'}
          </button>
          <button
            onClick={signOut}
            className="rounded-md border border-mms-border px-2.5 py-1.5 text-xs text-mms-muted hover:border-[var(--mms-hover-border)]"
          >
            {t('Sign out')}
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-2xl px-4 py-16">
        <div className="rounded-lg border border-mms-border bg-mms-surface p-8 shadow-[var(--mms-elev-2)]">
          <h1 className="text-lg font-semibold">{t('Marketing Management System')}</h1>
          <p className="mt-2 text-sm text-mms-muted">{t('Phase 0 — foundation online.')}</p>
          <p className="mt-1 text-sm text-mms-muted">
            {t('The rewards engine, affiliate tracking and wallet arrive in the next phases.')}
          </p>
          <dl className="mt-6 space-y-1 text-sm">
            <div className="flex gap-2">
              <dt className="text-mms-faint">{t('Signed in as')}:</dt>
              <dd>{user?.name || '—'}</dd>
            </div>
            <div className="flex gap-2">
              <dt className="text-mms-faint">{t('Role')}:</dt>
              <dd>{user?.mr ? t(user.mr) : user?.role || '—'}</dd>
            </div>
          </dl>
        </div>
      </main>
    </div>
  );
}
